<div class="modal-header align-items-center">
  <h4 class="modal-title pull-left">
    {{ "Upload_Instructions.instructions" | translate }}
  </h4>
  <div>
    <city-tax-language-selector></city-tax-language-selector>
    <button (click)="bsModalRef.hide()" class="text-muted">
      <svg class="icon" viewBox="0 0 24 24">
        <path
            d="M13.46,12L19,17.54V19H17.54L12,13.46L6.46,19H5V17.54L10.54,12L5,6.46V5H6.46L12,10.54L17.54,5H19V6.46L13.46,12Z"
            stroke="none"
        />
      </svg>
    </button>
  </div>
</div>
<div class="scrollable scrollable-y">
  <div class="scrollable-content">
    <div class="modal-body">
      <div [innerHtml]="'Upload_Instructions.mi' | translate: {cityName: config.name}"
          class="font-weight-bold">
      </div>
    </div>
  </div>
</div>
